import { FaDownload } from "react-icons/fa";
import Modal from "../ui/Modal";
import Spinner from "../ui/Spinner";
import useApiQuery from "../../hooks/useApiQuery";
import endpoints from "../../api/endpoints";

/** Story image for sharing, with a download button. */
const ShareModal = ({ open, onClose, id, type }) => {
  const { data, loading } = useApiQuery(
    open && id ? endpoints.story(type, id) : null
  );
  const imageUrl = data?.image;

  const handleDownload = () => {
    if (!imageUrl) return;
    const link = document.createElement("a");
    link.href = imageUrl;
    link.setAttribute("download", "downloaded_image.jpg");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal open={open} onClose={onClose} className="max-w-[400px] bg-white">
      <div className="p-4">
        {loading ? (
          <div className="flex flex-col items-center gap-4 py-8 text-black">
            <Spinner size="sm" />
            <p>در حال بارگذاری تصویر...</p>
          </div>
        ) : imageUrl ? (
          <div className="flex flex-col items-center">
            {/* 177.78% keeps the 1080x1920 story aspect ratio */}
            <div className="relative mb-4 w-full pt-[177.78%]">
              <img
                src={imageUrl}
                alt="تصویر اشتراک‌گذاری"
                className="absolute inset-0 h-full w-full rounded-md object-cover"
              />
            </div>
            <button
              type="button"
              onClick={handleDownload}
              className="rounded-full bg-brand px-4 py-2 font-bold text-white transition hover:bg-brand-dark"
              aria-label="دانلود"
            >
              <FaDownload size={20} />
            </button>
          </div>
        ) : (
          <p className="py-8 text-center text-black">تصویری موجود نیست</p>
        )}
      </div>
    </Modal>
  );
};

export default ShareModal;
